import React from 'react';
import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from '../../Shared/Icon/Icon';

export default function TutorialCard(props) {
  function onCategoryChange(value, isChecked) {
    return props.onCategoryFilterChange(value, isChecked);
  }

  function onSoftwareChange(value, isChecked) {
    return props.onSoftwareFilterChange(value, isChecked);
  }

  const softwareTagsNode = props.data.attributes.software.slice(0, 2).map((software) => {
    return <li key={software}>{software}</li>;
  });

  const categoryTagsNode = props.data.attributes.categories.slice(0, 2).map((category) => {
    return <li key={category}>{category}</li>;
  });

  return (
    <div className="tutorial__content card card--flat">
      <div className="tutorials__item row">
        <div className="col-sm-12 col-md-2">
          <div className="tutorials-item__image">
            <img alt={props.data.attributes.title} src={props.data.attributes.image.url} />
          </div>
        </div>
        <div className="col-sm-12 col-md-10">
          <div className="tutorials-item__content">
            <a href={props.data.links.self} className="cgt-legacy-link">
              <h3 className="tutorials__title">{props.data.attributes.title}</h3>
            </a>
            <h4 className="tutorials__author">
              <span>By </span>
              <a href={props.data.relationships.user.links.self} className="cgt-legacy-link">
                {props.user.attributes.fullName}
              </a>
            </h4>
            <div className="tutorials-item__info">
              <div className="tags-container">
                <div className="tag-list software">
                  <ul>
                    <Icon type="wrench" size="lg" />
                    {softwareTagsNode}
                  </ul>
                </div>
                <div className="tag-list">
                  <ul>
                    <Icon type="check" size="lg" />
                    {categoryTagsNode}
                  </ul>
                </div>
              </div>
              <div className="tutorials-item__info tutorials-item__info--mobile">
                <div className="community-links">
                  <div className="community-list">
                    <Icon type="heart" />
                    <span>{props.data.attributes.likes}</span>
                  </div>
                  <div className="community-list">
                    <Icon type={['far', 'comment-alt']} />
                    <span>{props.data.attributes.comments}</span>
                  </div>
                  <div className="community-list">
                    <Icon type="eye" />
                    <span>{props.data.attributes.pageviews}</span>
                  </div>
                </div>
                <div className="tutorials-button__content">
                  <Button
                    href={props.data.links.self}
                    type="primary"
                    size="small"
                    customClass="pull-right"
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
